export default "__VITE_ASSET__BSWraEwK__"